import React, { Component } from 'react';
import 'react-phone-number-input/style.css'
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input/input'
// import { getNumberType } from 'libphonenumber-js'
import libphonenumber,{ parsePhoneNumber } from 'libphonenumber-js/max';
import it from 'react-phone-number-input/locale/it.json'
import { isUndefined } from 'lodash';

export default class InputPhoneEstero extends Component {
    constructor(props) {
        super(props);

        let showError = false
        if (this.props.invalid_message != undefined && this.props.invalid_message !== '') {
            showError = true
        }

        this.state = {
            phone: this.props.value.replace(/ /g, ''),
            showError: showError,
            errorText: this.props.invalid_message
        };

        this.handlePhoneChange = this.handlePhoneChange.bind(this); // Binding di this
    }

    handlePhoneChange = (value) => {
        let errorText = value;
        let validNumberType = ['MOBILE', 'FIXED_LINE_OR_MOBILE'];

        if(value){
            // if(isValidPhoneNumber(value)){
            //     let numberType = getNumberType(value)
            //     console.log('Tipo di numero: ', numberType)
            //     if(this.props.onlyMobile && numberType !== 'MOBILE'){
            //         errorText = 'Inserire un numero di telefono cellulare'
            //     } else {
            //         errorText = undefined;
            //     }
            // } else {
            //     errorText = 'Numero di telefono non valido'
            // }

            // rimosso isValidPhoneNumber(value) perchè ha un bug con i numeri di telefono americani. Si usa la validazione con parsePhoneNumber e phoneNumber.isValid
            try {
                const phoneNumber = parsePhoneNumber(value);

                /**
                 * per i numeri di telefono americani, sembra non essere possibile distinguere tra numero di telefono fisso e numero di cellulare
                 * si verifica quindi se il numberType è 'MOBILE' o 'FIXED_LINE_OR_MOBILE'
                */
                if (phoneNumber && phoneNumber.isValid()) {
                    const numberType = phoneNumber.getType(); // 'MOBILE', 'FIXED_LINE', ecc.
                    console.log('Tipo di numero: ', numberType);

                    if (this.props.onlyMobile && !validNumberType.includes(numberType)) {
                        // Se il numero non è di tipo 'MOBILE' o 'FIXED_LINE_OR_MOBILE'
                        errorText = 'Inserire un numero di telefono cellulare';
                    } else {
                        errorText = undefined;
                    }
                } else {
                    errorText = 'Numero di telefono non valido';
                    //console.error('Numero di telefono non valido:', value);
                }
            } catch (e) {
                errorText = 'Formato telefonico non valido';
                //console.error('Errore durante la validazione del numero di telefono:', e);
            }

        } else {
            errorText = 'Inserire un numero di telefono'
        }

        let showError = isUndefined(errorText) ? false : true

        // Rimuovi tutto tranne i numeri dopo il prefisso e limita la lunghezza a 10 cifre
        this.setState({ phone: value });
        this.setState({ showError: showError }); // Nasconde l'errore quando il numero non è vuoto
        this.setState({ errorText: errorText });
    };

    render() {
        var classValidation = '';
        var requiredClass = '';

        // Controlla la validità
        if (this.state.showError) {
            classValidation = 'is-invalid';
        }

        // Verifica su required
        if (this.props.required) {
            requiredClass = 'nam_required';
        }

        return (
            <div className="form-group row">
                <div className={"col-sm-12"}>
                    <label htmlFor={this.props.name} className="col-form-label font-weight-bold">{this.props.label}</label>
                    <div className="input-group">
                        <div className='w-100'>
                            <PhoneInput
                                value={this.state.phone}
                                onChange={this.handlePhoneChange}
                                className={'form-control ' + classValidation + ' ' + requiredClass}
                                label={this.props.cellulare}
                                defaultCountry="IT"
                                international={true}
                                withCountryCallingCode={true}
                                readOnly={this.props.readOnly}
                                maxLength={this.props.maxLength}
                                required={true}
                            />
                            <small style={{ color: '#666' }}>Inserisci un numero corretto e completo di prefisso internazionale: verrà usato per completare la firma elettronica dei contratti di attivazione. (prefisso +39 aggiunto automaticamente per i numeri italiani)<br/>Potrai verificarlo anche nella pagina successiva di riepilogo.</small>
                            <input type="hidden" name={this.props.name} value={this.state.phone||''} readOnly/>

                            {/* Condizione per mostrare il messaggio di errore */}
                            {this.state.showError && (
                            <div className="invalid-feedback" data-testid="message">
                                {this.state.errorText}
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

